import { render } from "./DevTest.vue?vue&type=template&id=32e4dd76"
import script from "./DevTest.vue?vue&type=script&lang=js"
export * from "./DevTest.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__